const SORTER_ORDER_POSITION = (a, b)=>{
    const aPosition = a?.orderPosition || 0;
    const bPosition = b?.orderPosition || 0;
    const result = aPosition - bPosition;
    return result;
};
Object.freeze(SORTER_ORDER_POSITION);
export { SORTER_ORDER_POSITION };
